import * as React from "react";
const SvgCloseSign = props => <svg width="inherit" height="inherit" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 5L19 19M19 5L5 19" strokeWidth={1.5} strokeLinecap="round" /></svg>;
export default SvgCloseSign;